class EngagementPopup extends DrupalBehavior {
  onContent(context) {
    var $window = $(window);
    var $document = $(document);
    $('.engagement-popup', context).each(function(){
      var $self = $(this);
      var id = $self.attr('data-id');
      var closed = false;
      $self.find('.engagement-popup--close, .engagement-popup--backdrop').click(function(){
        closed = true;
        $self.removeClass('active');
        var config = {};
        var cookieExpiry = $self.attr('data-cookie-expiry');
        switch (cookieExpiry) {
          case '14 days':
            cookieExpiry = 14;
            break;
          case '1 day':
            cookieExpiry = 1;
            break;
          case '7 days':
            cookieExpiry = 7;
            break;
          case 'never':
            cookieExpiry = Infinity;
            break;
          case 'no cookie':
            cookieExpiry = 0;
            break;
          case '30 days':
            cookieExpiry = 30;
            break;
        }
        if (cookieExpiry >= 0) {
          config.expires = cookieExpiry;
        }
        Cookies.set('engagement-popup--' + id, 'closed', config);
      });
      if (Cookies.get('engagement-popup--' + id)) {
        return;
      }
      var scrollDepth = $self.attr('data-scroll-depth');
      if (scrollDepth == 0) {
        if (closed) {
          return;
        }
        $self.addClass('active');
      } else {
        $window.scroll(function(){
          if (closed) {
            return;
          }
          var scrollPercent = 100 * $window.scrollTop() / ($document.height() - $window.height());
          if (scrollPercent >= scrollDepth && !$self.hasClass('active')) {
            $self.addClass('active');
          }
        });
      }
    });
  }
}

DrupalBehavior.register('summit_theme', 'engagement_popup', EngagementPopup);
